<template>
  <div class="couette-flow-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>u(y) = (U/h)y | 剪切流速线性分布$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Top Moving Plate -->
          <g transform="translate(0, 60)">
             <rect width="400" height="10" fill="#444" stroke="#888" />
             <line v-for="i in 10" :key="i" :x1="(i*40 + t*velocity)%440 - 20" y1="5" :x2="(i*40 + t*velocity)%440 - 10" y2="5" stroke="#ffd700" stroke-width="2" />
             <text x="160" y="-10" fill="#ffd700" font-size="10">上极板速度 U</text>
          </g>

          <!-- Bottom Fixed Plate -->
          <rect x="0" y="180" width="400" height="10" fill="#222" stroke="#888" />
          <text x="160" y="210" fill="#888" font-size="8">下极板固定</text>
          
          <!-- Velocity Vectors -->
          <g v-for="i in 8" :key="'v'+i" :transform="`translate(${50 + i*40}, 0)`">
             <line v-for="j in 6" :key="'j'+j" 
                   x1="0" :y1="180 - j*20" :x2="j*velocity*0.5" :y2="180 - j*20" 
                   stroke="rgba(0, 210, 255, 0.6)" stroke-width="1" marker-end="url(#arrow-v)" />
          </g>

          <!-- Fluid layers -->
          <rect x="0" y="70" width="400" height="110" fill="rgba(0, 210, 255, 0.05)" />

          <defs>
            <marker id="arrow-v" markerWidth="4" markerHeight="4" refX="4" refY="2" orient="auto">
               <path d="M0,0 L4,2 L0,4 Z" fill="rgba(0, 210, 255, 0.8)" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>剪切应力 τ = μ (du/dy)</label>
              <div class="value" style="color: #00d2ff">形态: 线性梯度流</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节极板速度</label>
             <el-slider v-model="velocity" :min="1" :max="20" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>库埃特流（Couette Flow）是流体力学中最简单的定常剪切流模型。当流体被置于两块平行的平板之间，其中一块板相对另一块板做等速运动时，由于流体的**粘性作用**，流体各层会被逐层带动。在理想状态下，流速从固定底板的零线性增加到顶板的U。这一模型常用于测量流体的动态粘度，也是理解轴承润滑和边界层理论的基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CouetteFlowViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      t: 0,
      velocity: 10,
      timer: null
    }
  },
  methods: {
    animate() {
       this.t += 1;
       this.timer = requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.couette-flow-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
